var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarningIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#warning-icon_svg__clip0_706_1698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.0003 16C12.4186 16 16 12.4179 16 8C16 3.58149 12.418 0 8.0003 0C3.58196 0 0 3.58209 0 8C0 12.4185 3.58196 16 8.0003 16Z",
    fill: "#FFA854"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.46759 9.83072C8.65438 9.83072 8.80556 9.9929 8.80556 10.1933V11.1374C8.80556 11.2336 8.76995 11.3258 8.70657 11.3938C8.64319 11.4618 8.55722 11.5 8.46759 11.5H7.58797C7.49833 11.5 7.41237 11.4618 7.34899 11.3938C7.28561 11.3258 7.25 11.2336 7.25 11.1374V10.1938C7.25 9.9929 7.40071 9.83072 7.58797 9.83072H8.46759ZM8.46759 4.5C8.65438 4.5 8.80556 4.66267 8.80556 4.86306V8.68128C8.80556 8.77744 8.76995 8.86966 8.70657 8.93766C8.64319 9.00565 8.55722 9.04385 8.46759 9.04385H7.58797C7.49833 9.04385 7.41237 9.00565 7.34899 8.93766C7.28561 8.86966 7.25 8.77744 7.25 8.68128V4.86306C7.25 4.66267 7.40071 4.50049 7.58797 4.50049H8.46759V4.5Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "warning-icon_svg__clip0_706_1698"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H16V16H0z"
  })))));
}

export default SvgWarningIcon;